// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33LAq","delete":"styles_delete__3finh","update":"styles_update__hrixO","add":"styles_add__294CM"};